import { StyleSheet } from 'react-native';

import { warrior } from '../../../constants/color';

const SIZE = 50;

const styles = StyleSheet.create({
  container: {
    width: SIZE,
    marginBottom: 20,
    alignItems: 'center',
    overflow: 'visible',
  },
  iconLoading: {
    marginBottom: 10,
    borderRadius: SIZE,
    width: SIZE,
    height: SIZE,
  },
  // 為了顯示陰影，背景圖片中有包含 6px 的 margin，這裏 layout 要額外計算處理
  iconBackground: {
    width: SIZE + 12,
    height: SIZE + 12,
    margin: -6,
    position: 'absolute',
    top: 0,
  },
  iconContainer: {
    width: SIZE,
    height: SIZE,
  },
  icon: {
    width: '100%',
    height: '100%',
  },
  name: {
    marginTop: 8,
    fontSize: 15,
    color: warrior,
    width: 100,
    textAlign: 'center',
  },
});

export default styles;
